import React from 'react';
import { useAppSelector } from 'hooks/redux';
import { Backdrop, CircularProgress } from '@mui/material';

export const BackdropLoad: React.FC<{
  isOpen: boolean;
  drawerWidth?: string;
}> = ({ isOpen, drawerWidth }) => {
  const { layer_scale_1_50_vector } = useAppSelector((state) => state.layers);
  const { isLogged } = useAppSelector((state) => state.mainPage);

  const showTabs = !isLogged && layer_scale_1_50_vector && drawerWidth;

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: 'fixed',
        left: showTabs ? drawerWidth : 0,
        top: 0,
      }}
      open={isOpen}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
